export default __webpack_public_path__ + "static/media/MRMlogotyp-1.7ae1d25e.png";